module.exports = __webpack_public_path__ + "static/img/1121_phase_function_Paper_PointsHejduk_Prediction.f2be907.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1121_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ybnO
// module chunks = 0